// Helper function for handling asset paths
export const publicPath = process.env.PUBLIC_URL || '';

// Function to get correct asset path
export const getAssetPath = (path) => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  // Since we're directly accessing assets from the assets folder
  return `${publicPath}/../assets/${cleanPath}`;
};

// Use this function for image paths
export const getImagePath = (imageName) => {
  // Direct path to the images folder
  return `${publicPath}/../assets/images/${imageName}`;
};

// Use this function for lottie animation paths
export const getLottiePath = (fileName) => {
  // Direct path to the lottie folder
  return `${publicPath}/../assets/lottie/${fileName}`;
};
